// extracted by mini-css-extract-plugin
export default {"back_container":"Backbar_back_container__sNu9N","icon_button":"Backbar_icon_button__DR6dz","back_icon":"Backbar_back_icon__qxMmY"};